import { useEffect, type MouseEvent } from 'react';

const SCROLL_POS_KEY = 'searchScroll';

/**
 * This is for supporting the old way to remember scroll position. Not needed for systems that support Navigation API
 */
export const rememberScrollPositionOnClick =
    typeof navigation === 'undefined'
        ? // Do this only if NavigationAPI isn't supported. NavigationAPI will capture the scroll position in the navigate event handler
          (event: MouseEvent<HTMLElement>) => {
              if (event.target instanceof HTMLElement && event.target.closest('a')) {
                  // If the user clicked on a link, save the current scroll position
                  sessionStorage.setItem(SCROLL_POS_KEY, scrollY.toString());
              }
          }
        : undefined;

export function rememberScrollPos() {
    if (typeof navigation !== 'undefined') {
        if (navigation.currentEntry) {
            navigation.updateCurrentEntry({
                state: { scrollPos: window.scrollY },
            });
        }
    }
}

let scrollHandled = false;
export function useHandleScrollFromHistory() {
    useEffect(() => {
        if (scrollHandled) return;

        scrollHandled = true;

        if (typeof navigation !== 'undefined') {
            const scrollPos = navigation.activation?.entry?.getState()?.scrollPos;

            if (scrollPos !== undefined) {
                scrollTo(0, scrollPos);
            }

            navigation.addEventListener('navigate', (e) => {
                const currentPageHasChanged = hasCurrentPageChanged(navigation.currentEntry?.url, e.destination.url);
                const shouldSaveScroll = !e.destination.sameDocument || currentPageHasChanged;

                if (shouldSaveScroll) {
                    navigation.updateCurrentEntry({
                        state: {
                            scrollPos: window.scrollY,
                        },
                    });
                }

                const shouldRestoreScroll = e.destination.sameDocument && currentPageHasChanged;

                if (shouldRestoreScroll) {
                    const scrollPos = e.destination?.getState()?.scrollPos;

                    scrollTo(0, scrollPos ?? 0);
                }
            });
        } else {
            // Handling going back from product page and keeping scroll position
            const fromBackButton = performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD;
            if (fromBackButton) scrollTo(0, parseInt(sessionStorage.getItem(SCROLL_POS_KEY) ?? '0') || 0);
            sessionStorage.removeItem(SCROLL_POS_KEY);
        }
    }, []);
}

function hasCurrentPageChanged(oldUrl?: string | null, newUrl?: string | null) {
    if (!oldUrl || !newUrl) return false;

    const oldPage = new URL(oldUrl).searchParams.get('currentPage');
    const newPage = new URL(newUrl).searchParams.get('currentPage');

    return oldPage !== newPage;
}
